export const actions = {
  set: 'SET::EMPLOYER_ACTIVE_FILTER'
}

export const setEmployerActiveFilter = filter => ({ type: actions.set, employerActiveFilter: filter })
export const getEmployerActiveFilter = state => state.employerActiveFilter

export default actions



// WEBPACK FOOTER //
// ./src/store/employer-active-filter/actions.js